class CheckoutUpsellsATC extends HTMLElement {
    connectedCallback() {
        this.addToCartButtons = this.querySelectorAll('.checkbox-upsell-button');
        this.upsellCheckboxes = document.querySelectorAll('.chkbox_upsell');

        this.addToCartButtons.forEach(button => {
            button.addEventListener('click', e => this.handleAddToCart(e));
        });

        this.upsellCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', e => this.handleCheckboxChange(e));
            this.updateActiveState(checkbox);
        });
    }

    handleCheckboxChange(event) {
        this.updateActiveState(event.target);
    }

    updateActiveState(checkbox) {
        const parentDiv = checkbox.closest('.checkbox-upsell');
        if (!parentDiv) return;

        if (checkbox.checked) {
            parentDiv.classList.add('active');
        } else {
            parentDiv.classList.remove('active');
        }
    }

    handleAddToCart(event) {
        event.preventDefault();

        const cartForm = this.closest('cart-form');
        const formAPI = cartForm?.formDataAPI;
        if (!cartForm || !formAPI) return;

        const dataForm = JSON.parse(cartForm.getAttribute('data-form') || '{}');
        const items = {};

        const allUpsellIds = new Set(
            Array.from(this.upsellCheckboxes)
                .map(cb => cb.closest('[data-variant-id]')?.dataset.variantId)
                .filter(Boolean)
        );

        Object.values(dataForm.items || {}).forEach(item => {
            if (!item?.id) return;

            const id = String(item.id);

            if (allUpsellIds.has(id) && !this.isUpsellChecked(id)) {
                return;
            }

            items[id] = {
                id: Number(item.id),
                quantity: Number(item.quantity) || 1,
                properties: item.properties || {}
            };

            if (item.selling_plan) {
                items[id].selling_plan = Number(item.selling_plan);
            }
        });

        const checkedUpsells = this.getCheckedUpsellsObject();
        for (const id in checkedUpsells) {
            items[id] = checkedUpsells[id];
        }

        formAPI.empty();

        Object.values(items)
            .reverse()
            .forEach(item => {
                formAPI.updateItems(item);
            });

        cartForm.reqCart();
    }

    isUpsellChecked(variantId) {
        return Array.from(this.upsellCheckboxes).some(cb => {
            if (!cb.checked) return false;
            const container = cb.closest('[data-variant-id]');
            return container?.dataset.variantId === variantId;
        });
    }

    getCheckedUpsellsObject() {
        const upsells = {};

        this.upsellCheckboxes.forEach(checkbox => {
            if (!checkbox.checked) return;

            const container = checkbox.closest('[data-variant-id]');
            if (!container) return;

            const variantId = String(container.dataset.variantId);

            upsells[variantId] = {
                id: Number(variantId),
                quantity: 1,
                properties: {}
            };

            if (container.dataset.subsId) {
                upsells[variantId].selling_plan = Number(container.dataset.subsId);
            }
        });

        return upsells;
    }
}

window.customElements.define('checkout-upsells-atc', CheckoutUpsellsATC);
